<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      :finish-button-text="$can('all','manage') && berkas.status_pengajuan_sidang_id == 'ae7ebb35d51267ce' ? 'Simpan' : 'Kembali ke Daftar Sidang'"
      back-button-text="Kembali"
      next-button-text="Lanjut"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <tab-content
        v-if="berkas.role == 'umum'"
        title="Penetapan Jadwal Sidang"
        :before-change="validationFormAddress2"
      >
        <validation-observer
          ref="addressRules2"
          tag="form"
        >
          <b-row v-if="$can('set-ruangan-sidang','pengajuan-sidang')">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Ruangan Terpakai
              </h5>
              <small class="text-muted">Daftar ruangan yang telah terpakai ujian</small>
            </b-col>
          </b-row>
          <b-row v-if="$can('set-ruangan-sidang','pengajuan-sidang')">
            <b-col md="12" class="mb-3" style="height: 200px;">
                <b-table hover :items="ruangan_terpakai" style="overflow: scroll;"></b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Ruangan Sidang"
                label-for="Ruangan Sidang"
              >
                <validation-provider
                  #default="{ errors }"
                  name="ruangan_sidang"
                  :rules="$can('set-ruangan-sidang','pengajuan-sidang') ? 'required' : ''"
                >
                  <v-select
                    id="ruangan"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="ruanganOption.options"
                    v-model="jadwal_sidang.ruangan_id"
                    placeholder="Pilih Ruangan"
                    :disabled="!$can('set-ruangan-sidang','pengajuan-sidang')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Tanggal Ujian"
                label-for="Tanggal Ujian"
              >
                <validation-provider
                  #default="{ errors }"
                  name="tanggal_ujian"
                  rules="required"
                >
                  <v-select
                    id="tanggal_ujian"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="tanggalUjianPenetapanOption.options"
                    v-model="jadwal_sidang.tanggal"
                    placeholder="Pilih Tanggal"
                    :disabled="!$can('manage','all-content') || berkas.is_ok_umum != null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="6">
              <b-form-group
                label="Waktu Ujian"
                label-for="Waktu Ujian"
              >
                <validation-provider
                  #default="{ errors }"
                  name="waktu_ujian"
                  rules="required"
                >
                  <v-select
                    id="waktu_ujian"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="waktuUjianPenetapanOption.options"
                    v-model="jadwal_sidang.waktu_ujian_id"
                    placeholder="Pilih Waktu Ujian"
                    :disabled="!$can('manage','all-content') || berkas.is_ok_umum != null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- Ini untuk ROLE UMUM -->
      <tab-content
        v-if="berkas.role != 'umum'"
        title="Form Pendaftaran"
        :before-change="validationForm"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Form Pendaftaran Ujian
              </h5>
              <small class="text-muted">
                Lengkapi form pendaftaran anda.
              </small>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="6">
              <b-form-group>
                <label for="">Jenjang <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jenjang"
                  rules="required"
                >
                  <v-select
                    id="jenjang"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jenjangOption.options"
                    v-model="berkas.jenjang_id"
                    placeholder="Pilih Jenjang"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Prodi <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="prodi"
                  rules="required"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="prodiOption.options"
                    v-model="berkas.prodi_id"
                    placeholder="Pilih prodi"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- //DATA SKRIPSI S1, S2, S3 MUNCUL KETIKA PILIH JENJANG -->
          <b-row v-if="berkas.jenjang_id != null">
            <b-col md="6">
              <b-form-group>
                <label for="">Nama Lengkap <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nama"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="berkas.name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nama Lengkap"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nama Ijazah <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nama"
                  rules="required"
                >
                  <b-form-input
                    id="nama_ijazah"
                    v-model="berkas.nama_ijazah"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nama Ijazah"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">NPM <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="npm"
                  rules="required"
                >
                  <b-form-input
                    id="npm"
                    v-model="berkas.npm"
                    :state="errors.length > 0 ? false:null"
                    placeholder="NPM"
                    :maxlength="10"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Angkatan <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="angkatan"
                  rules="required"
                >
                  <b-form-input
                    id="angkatan"
                    v-model="berkas.angkatan"
                    :state="errors.length > 0 ? false:null"
                    placeholder="2023"
                    type="number"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Tempat Lahir <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="tempat_lahir"
                  rules="required"
                >
                  <b-form-input
                    id="tempat_lahir"
                    v-model="berkas.tempat_lahir"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Tempat Lahir"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Tanggal Lahir <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="tanggal_lahir"
                  rules="required"
                >
                  <!-- <b-form-datepicker v-model="berkas.tanggal_lahir" locale="id" :disabled="true"></b-form-datepicker> -->
                  <flat-pickr
                      v-model="berkas.tanggal_lahir"
                      class="form-control invoice-edit-input"
                      :config="flatpickrConfig"
                      :disabled="true"
                    />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Alamat Mahasiswa <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="alamat"
                  rules="required"
                >
                  <b-form-textarea
                  :state="errors.length > 0 ? false:null"
                  id="alamat"
                  v-model="berkas.alamat"
                  placeholder="alamat..."
                  rows="3"
                  :disabled="true"
                ></b-form-textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
             <b-col md="6">
              <b-form-group>
                <label for="">Alamat Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="alamat"
                  rules="required"
                >
                   <b-form-textarea
                  :state="errors.length > 0 ? false:null"
                  id="alamat"
                  v-model="berkas.alamat_orang_tua"
                  placeholder="alamat..."
                  rows="3"
                  :disabled="true"
                ></b-form-textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Pekerjaan Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="pekerjaan_orang_tua"
                  rules="required"
                >
                  <b-form-input
                    id="pekerjaan_orang_tua"
                    v-model="berkas.pekerjaan_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Pekerjaan Orang Tua"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Jabatan Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jabatan_orang_tua"
                  rules="required"
                >
                  <b-form-input
                    id="jabatan_orang_tua"
                    v-model="berkas.jabatan_orang_tua"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Jabatan Orang Tua"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nomor Telp <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nomor_telp"
                >
                  <b-form-input
                    id="nomor_telp"
                    v-model="berkas.nomor_telp"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor Telpon Rumah"
                    type="number"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nomor HP <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nomor_hp"
                  rules="required"
                >
                  <b-form-input
                    id="nomor_hp"
                    v-model="berkas.nomor_hp"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor HP"
                    type="number"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Alamat Email UI <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="berkas.email_ui"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Alamat Email Selain UI <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="berkas.email_selain_ui"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3" v-if="berkas.jenjang_id != null">
           <b-col md="6">
              <b-form-group>
                <label for="">Judul <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="judul"
                  rules="required"
                >
                <b-form-textarea
                    id="judul"
                    v-model="berkas.judul"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Judul"
                    rows="5"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
             <b-col md="6">
              <b-form-group>
                <label for="">Penelitian Payung <span style="color: blue;">(Opsional)</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="penelitian_payung"
                >
                  <b-form-input
                    id="penelitian_payung"
                    v-model="berkas.penelitian_payung"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Penilitian Payung"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <div v-if="berkas.jenjang_id != null">
            <b-row>
              <b-col md="12">
                  <div class="d-flex justify-content-end" style="margin-bottom: 20px; margin-top: 20px;">
                    <b-spinner
                    style="margin-right: 10px; margin-top:5px;"
                    :variant="'dark'"
                    v-if="showSpinner == 1"
                  ></b-spinner>
                  </div>
              </b-col>
            </b-row>
            <b-row  v-for="item in berkas.waktu_ujian" :key="item.id">
              <b-col md="6">
                <b-form-group>
                  <label for="">Usulan Tanggal Ujian <span style="color: red; font-size: 16px;">*</span></label>
                  <validation-provider
                    #default="{ errors }"
                    name="tanggal_sidang"
                    rules="required"
                  >
                    <!-- <b-form-datepicker v-model="item.tanggal_ujian" locale="id" :disabled="true"></b-form-datepicker> -->
                    <flat-pickr
                      v-model="item.tanggal_ujian"
                      class="form-control invoice-edit-input"
                      :config="flatpickrConfig"
                      :disabled="!$can('manage','all-content')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
                <b-col md="5">
                  <b-form-group>
                    <label for="">Usulan Waktu Ujian <span style="color: red; font-size: 16px;">*</span></label>
                    <validation-provider
                      #default="{ errors }"
                      name="waktu_ujian"
                      rules="required"
                    >
                    <v-select
                      id="waktu_ujian_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :reduce="val => val.value"
                      :options="waktuUjianOption.options"
                      v-model="item.waktu_ujian_id"
                      placeholder="Pilih Waktu"
                      :disabled="!$can('manage','all-content')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>  
          </div>
          <b-row v-if="berkas.jenjang_id != null">
            <!-- <b-col md="6">
              <b-form-group>
               <label for="">Skema Ujian <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="skema_ujian"
                  rules="required"
                >
                  <v-select
                    id="skema_ujian"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="prosesPersidanganOption.options"
                    v-model="berkas.skema_ujian_id"
                    placeholder="Pilih Skema Ujian"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <b-col md="12" class="mt-2 mb-2" v-if="berkas.role == 'admin'">
                <div class="d-flex">
                  <div class="mr-1 mt-1">
                    <b-button id="show-btn" @click="$bvModal.show(`jadwal-dosen`)" variant="primary">Lihat Jadwal Dosen</b-button>
  
                    <b-modal :id="`jadwal-dosen`" hide-footer size="lg">
                      <template #modal-title>
                        Jadwal Dosen Yang Telah Terdaftar Sidang
                      </template>
                      <div class="d-block text-left">
                        <div>
                          <jadwal-sidang-dosen />
                        </div>
                      </div>
                      <b-button class="mt-3" block @click="$bvModal.hide(`jadwal-dosen`)" variant="danger">Tutup</b-button>
                    </b-modal>
                  </div>
                </div>
              </b-col>
          </b-row>
          <b-row v-if="berkas.jenjang_id != null">
              <b-col md="12">
                  <div class="d-flex justify-content-end" style="margin-top: 20px;">
                    <b-spinner
                    style="margin-right: 10px; margin-top:5px;"
                    :variant="'dark'"
                    v-if="showSpinnerPembimbing == 1"
                  ></b-spinner>
                  </div>
              </b-col>
          </b-row>
          <b-row v-if="berkas.jenjang_id != null" v-for="(item, index) in berkas.dosen_pembimbing" :key="item.id" style="margin-bottom: 20px;">
            <b-col md="6">
              <b-form-group>
                <label for="">Dosen Pembimbing {{ index += 1 }} <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing"
                  rules="required"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="item.dosen_pembimbing_id"
                    placeholder="Pilih Dosen Pembimbing"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
                <label for="">Alamat Email Pembimbing {{ index }} <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="item.email"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Pembimbing Utama ?<span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Pembimbing Utama"
                  rules="required"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenUtamaOption.options"
                    v-model="item.pembimbing_utama"
                    placeholder="Pilih"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="berkas.jenjang_id != null">
            <b-col md="6">
              <b-form-group>
                <label for="">Dosen Pembimbing Akademik <span style="color: red;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="berkas.dosen_pembimbing_akademik_id"
                    placeholder="Pilih Dosen Pembimbing Akademik"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="berkas.jenjang_id != null">
            <b-col md="6">
              <b-form-group>
                <label for="">Dosen Pembimbing Skripsi Magang <span style="color: blue;">(Opsional)</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing Magang"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="berkas.dosen_pembimbing_magang_id"
                    placeholder="Pilih Dosen Pembimbing Magang"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="berkas.jenjang_id != null">
              <b-col md="12">
                  <div class="d-flex justify-content-end" style="margin-top: 20px;">
                    <b-spinner
                    style="margin-right: 10px; margin-top:5px;"
                    :variant="'dark'"
                    v-if="showSpinnerPenguji == 1"
                  ></b-spinner>
                  </div>
              </b-col>
          </b-row>
          <b-row class="mt-3" v-if="berkas.jenjang_id != null" v-for="(item, index) in berkas.dosen_penguji" :key="item.id" style="margin-bottom: 20px;">
            <b-col md="6">
              <b-form-group>
                <label for="">Dosen Penguji {{ index += 1 }} <span style="color: red; font-size: 16px;">{{ index === 1 ? '*' : '' }}</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Penguji"
                  :rules="index == 1 ? 'required' : ''"
                >
                   <v-select
                    id="dosen_penguji_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="item.dosen_penguji_id"
                    placeholder="Pilih Dosen Penguji"
                    :disabled="berkas.role != 'admin'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Apakah Penguji {{ index }} sudah setuju untuk menguji skripsi Anda? <span style="color: red; font-size: 16px;">{{ index === 1 ? '*' : '' }}</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing"
                  :rules="index == 1 ? 'required' : ''"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jawabanPersetujuanOption.options"
                    v-model="item.jawaban_persetujuan_id"
                    placeholder="Pilih Jawaban"
                    :disabled="berkas.role != 'admin'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="berkas.role == 'admin'">
              <b-form-group>
                <label for="">Penguji Utama ?<span style="color: red; font-size: 16px;">{{ index === 1 ? '*' : '' }}</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Penguji"
                  :rules="index == 1 ? 'required' : ''"
                >
                   <v-select
                    id="dosen_penguji"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenUtamaOption.options"
                    v-model="item.penguji_utama"
                    placeholder="Pilih"
                    :disabled="berkas.role != 'admin'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <b-form-group>
                <label for="">Dosen Penguji 2 <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Penguji"
                  rules="required"
                >
                   <v-select
                    id="dosen_penguji_2_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="berkas.dosen_penguji_2_id"
                    placeholder="Pilih Dosen Penguji 2"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Apakah Penguji 1 sudah setuju untuk menguji skripsi Anda? <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing"
                  rules="required"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jawabanPersetujuanOption.options"
                    v-model="berkas.jawaban_dosen_penguji_2_id"
                    placeholder="Pilih Jawaban"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row class="mt-3" v-if="berkas.jenjang_id == 'd7502c8f68d11921bdf217e8fd173a69'">
            <b-col md="6">
              <b-form-group>
                <label for="">Awal Bimbingan Skripsi <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="awal_bimbingan"
                  rules="required"
                >
                  <!-- <b-form-datepicker v-model="berkas.awal_bimbingan"  locale="id" :disabled="true"></b-form-datepicker> -->
                  <flat-pickr
                      v-model="berkas.awal_bimbingan"
                      class="form-control invoice-edit-input"
                      :config="flatpickrConfig"
                      :disabled="true"
                    />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
             <b-col md="6">
              <b-form-group>
                <label for="">Akhir Bimbingan Skripsi <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="akhir_bimbingan"
                  rules="required"
                >
                  <!-- <b-form-datepicker v-model="berkas.akhir_bimbingan"  locale="id" :disabled="true"></b-form-datepicker> -->
                  <flat-pickr
                      v-model="berkas.akhir_bimbingan"
                      class="form-control invoice-edit-input"
                      :config="flatpickrConfig"
                      :disabled="true"
                    />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
              <label for="">Semester yang dijalani saat ini <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="semester_saat_ini"
                  rules="required"
                >
                  <b-form-input
                    id="semester_saat_ini"
                    v-model="berkas.semester_saat_ini"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Jumlah SKS Semester ini"
                    type="number"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
              <label for="">Lama Bimbingan Skripsi (Dalam Bulan) <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="lama_bimbingan"
                  rules="required"
                >
                  <b-form-input
                    id="lama_bimbingan"
                    v-model="berkas.lama_bimbingan"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Dalam Bulan"
                    type="number"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
               <label for="">Jumlah SKS diperoleh (Acuan SIAK NG) <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jumlah_sks_diperoleh"
                  rules="required"
                >
                  <b-form-input
                    id="jumlah_sks_diperoleh"
                    v-model="berkas.jumlah_sks_diperoleh"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Acuan SIAK NG"
                    type="number"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
               <label for="">Jumlah SKS diperoleh (Transfer Kredit) <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jumlah_sks_diperoleh_transfer_kredit"
                  rules="required"
                >
                  <b-form-input
                    id="jumlah_sks_diperoleh_transfer_kredit"
                    v-model="berkas.jumlah_sks_diperoleh_transfer_kredit"
                    :state="errors.length > 0 ? false:null"
                    placeholder="SKS Transfer Kredit"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group
              title="Untuk Melihat Total SKS Lulus, Silahkan cek pada SIAK NG."
             >
                <label for="">
                  Total SKS Lulus
                  <span style="color: red; font-size: 16px;">* </span>
                  <feather-icon icon="InfoIcon"/>
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="keterangan_kekurangan_sks"
                >
                  <b-form-input
                    id="keterangan_kekurangan_sks"
                    v-model="berkas.keterangan_kekurangan_sks"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Total SKS Lulus"
                    type="number"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group
              title="Untuk Melihat Total Mutu yang diperoleh, Silahkan cek pada SIAK NG."
             >
              <label for="">Total Mutu diperoleh <span style="color: red; font-size: 16px;">* </span><feather-icon icon="InfoIcon"/></label>
                <validation-provider
                  #default="{ errors }"
                  name="jumlah_mutu_diperoleh"
                  rules="required"
                >
                  <b-form-input
                    id="jumlah_mutu_diperoleh"
                    v-model="berkas.jumlah_mutu_diperoleh"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Acuan SIAK NG"
                    type="number"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
              <label for="">Jumlah SKS Semester ini yang sedang diambil <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="jumlah_sks_semester_ini"
                  rules="required"
                >
                  <b-form-input
                    id="jumlah_sks_semester_ini"
                    v-model="berkas.jumlah_sks_semester_ini"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Jumlah SKS Semester ini"
                    type="number"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
             <b-form-group>
              <label for="">IPK (Sebelum Ujian Skripsi) <span style="color: red; font-size: 16px;">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="ipk_sebelum_ujian"
                  rules="required"
                >
                  <b-form-input
                    id="ipk_sebelum_ujian"
                    v-model="berkas.ipk_sebelum_ujian"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Acuan SIAK NG"
                    type="number"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- personal details tab -->
      <tab-content
        v-if="berkas.role != 'umum'"
        title="Berkas Sidang"
        :before-change="validationFormInfo"
      >
        <validation-observer
          ref="infoRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Berkas Sidang
              </h5>
              <small class="text-muted">Lengkapi Berkas Sidang Anda</small>
            </b-col>
          </b-row>
          <b-row v-for="item in berkas.berkas_pengajuan" :key="item.berkas_pengajuan_uuid" style="margin-bottom: 10px;">
            <b-col md="4">
              <b-form-group>
                <label for="" style="margin-left: 15px;">{{ item.title }} <span style="color: red; font-size: 16px;" v-if="item.is_required">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  :name="item.title"
                >
                <div class="d-flex">
                  <b-button
                  v-if="item.file != null"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="mb-75 mr-75 ml-1 btn-block"
                    @click="lihatFile(item.file)"
                  >
                    Lihat <feather-icon icon="FileIcon" />
                  </b-button>
                  <div>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      :variant="(($can('set-note-berkas', 'pengajuan-sidang') || $can('manage', 'all-content')) && item.note == null) ? 'outline-primary' : 'danger'"
                      class="mb-75 mr-75 ml-1"
                      @click="$bvModal.show(`bv-modal-note${item.berkas_pengajuan_uuid}`)"
                      v-if="$can('set-note-berkas', 'pengajuan-sidang') || $can('manage', 'all-content')"
                    >
                      Catatan
                    </b-button>
                    <b-modal :id="`bv-modal-note${item.berkas_pengajuan_uuid}`" hide-footer>
                      <template #modal-title>
                        Catatan Perbaikan Berkas
                      </template>
                      <div class="d-block text-center">
                        <b-form-textarea rows="5" placeholder="Catatan Perbaikan" v-model="item.note"></b-form-textarea>
                      </div>
                      <center v-if="$can('set-note-berkas', 'pengajuan-sidang') || $can('manage', 'all-content')">
                        <b-button class="mt-3 mr-1" variant="primary" @click="simpanNote(item.berkas_pengajuan_uuid, item.note)">Simpan</b-button>
                        <b-button class="mt-3" variant="danger" @click="$bvModal.hide(`bv-modal-note${item.berkas_pengajuan_uuid}`)">Batal</b-button>
                      </center>>
                    </b-modal>
                  </div>
                </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
               <label for="">{{ item.description }}</label>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <tab-content
        v-if="($can('manage','all-content') || $can('set-ruangan-sidang', 'pengajuan-sidang') || $can('dekanat','pengajuan-sidang')) && berkas.role != 'umum'"
        title="Penetapan Jadwal Sidang"
        :before-change="validationFormAddress2"
      >
        <validation-observer
          ref="addressRules2"
          tag="form"
        >
          <b-row v-if="$can('set-ruangan-sidang','pengajuan-sidang')">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Ruangan Terpakai
              </h5>
              <small class="text-muted">Daftar ruangan yang telah terpakai ujian</small>
            </b-col>
          </b-row>
          <b-row v-if="$can('set-ruangan-sidang','pengajuan-sidang')">
            <b-col md="12" class="mb-3" style="height: 200px;">
                <b-table hover :items="ruangan_terpakai" style="overflow: scroll;"></b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Ruangan Sidang"
                label-for="Ruangan Sidang"
              >
                <validation-provider
                  #default="{ errors }"
                  name="ruangan_sidang"
                  :rules="$can('set-ruangan-sidang','pengajuan-sidang') ? 'required' : ''"
                >
                  <v-select
                    id="ruangan"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="ruanganOption.options"
                    v-model="jadwal_sidang.ruangan_id"
                    placeholder="Pilih Ruangan"
                    :disabled="!$can('manage','all-content')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Tanggal Ujian"
                label-for="Tanggal Ujian"
              >
                <validation-provider
                  #default="{ errors }"
                  name="tanggal_ujian"
                  rules="required"
                >
                  <v-select
                    id="tanggal_ujian"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="tanggalUjianPenetapanOption.options"
                    v-model="jadwal_sidang.tanggal"
                    placeholder="Pilih Tanggal"
                    :disabled="!$can('manage','all-content')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="6">
              <b-form-group
                label="Waktu Ujian"
                label-for="Waktu Ujian"
              >
                <validation-provider
                  #default="{ errors }"
                  name="waktu_ujian"
                  rules="required"
                >
                  <v-select
                    id="waktu_ujian"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="waktuUjianPenetapanOption.options"
                    v-model="jadwal_sidang.waktu_ujian_id"
                    placeholder="Pilih Waktu Ujian"
                    :disabled="!$can('manage','all-content')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <tab-content
        v-if="$can('dekanat', 'pengajuan-sidang')"
        title="Surat Tugas"
        :before-change="validationFormAddress3"
      >
        <validation-observer
          ref="addressRules3"
          tag="form"
        >
          <b-row v-if="$can('dekanat','pengajuan-sidang')">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Surat Tugas
              </h5>
              <small class="text-muted">Surat tugas untuk penguji</small>
            </b-col>
          </b-row>
          <!-- <b-row class="mb-3">
            <b-col md="6">
              <b-form-group
                label="Nomor Surat Tugas Pembimbing"
                label-for="Nomor Surat Tugas Pembimbing"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nomor Surat Tugas Pembimbing"
                  :rules="$can('dekanat','pengajuan-sidang') ? 'required' : ''"
                >
                  <b-form-input
                    id="nomor_surat"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor Surat Tugas Pembimbing"
                    :disabled="!$can('dekanat','pengajuan-sidang')"
                    v-model="surat_tugas.nomor_surat_tugas_pembimbing"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Pembimbing"
                label-for="Pembimbing"
              >
                <b-table hover :items="tim_pembimbing" style="overflow: scroll;"></b-table>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row class="mb-3">
            <b-col md="6">
              <b-form-group
                label="Nomor Surat Tugas Penguji"
                label-for="Nomor Surat Tugas Penguji"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nomor Surat Tugas Penguji"
                  :rules="$can('dekanat','pengajuan-sidang') ? 'required' : ''"
                >
                  <b-form-input
                    id="nomor_surat"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Nomor Surat Tugas Penguji"
                    :disabled="!$can('dekanat','pengajuan-sidang')"
                    v-model="surat_tugas.nomor_surat_tugas_penguji"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Penguji"
                label-for="Penguji"
              >
                <b-table hover :items="tim_penguji" style="overflow: scroll;"></b-table>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- address  -->
      <tab-content
        title="Konfirmasi"
        :before-change="validationFormAddress"
        v-if="(berkas.role == 'pembimbing' || berkas.role == 'admin' || berkas.role == 'umum' || berkas.role == 'dekanat')"
      >
        <validation-observer
          ref="addressRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
            <center style="margin-top: 70px;">
              Periksa kembali dan pastikan data dan berkas sudah sesuai untuk diproses.
            </center>
            <div class="d-flex justify-content-center" v-if="(berkas.role == 'pembimbing' || berkas.role == 'admin' || berkas.role == 'umum' || berkas.role == 'dekanat')" style="margin-top: 20px; margin-bottom: 100px;">
              <div class="mr-1" v-if="berkas.is_ok_umum == 'ya'">
                <b-button v-b-modal.modal-center-pembimbing-terima variant="primary">Setuju</b-button>
                <b-modal id="modal-center-pembimbing-terima" centered title="Konfirmasi" :hide-footer="true">
                  <center>
                    <label>Nomor Surat Nota Dinas</label>
                    <b-form-input
                    id="nomor_surat"
                    v-model="berkas.nomor_surat"
                    placeholder="Contoh : ND-96/UN2.F8.Prodi Sarjana/PDP.04.04/2024"
                  />
                  </center>
                  <br>
                  <center><p>Lengkapi nomor surat nota dinas dan klik ya untuk menetapkan jadwal sidang</p></center>
                  <div class="d-flex justify-content-center mt-2">
                      <b-button variant="success" class="mr-1" @click="terimaBerkas(berkas.role)" :disabled="berkas.nomor_surat == null">Ya</b-button>
                      <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-terima')">Tidak</b-button>
                  </div>
                </b-modal>
              </div>
              <div class="mr-1" v-else>
                <b-button v-b-modal.modal-center-pembimbing-terima variant="primary">Setuju</b-button>
                <b-modal id="modal-center-pembimbing-terima" centered title="Konfirmasi" :hide-footer="true">
                  <center><p>Apakah anda setuju untuk menetapkan jadwal sidang ini?</p></center>
                  <div class="d-flex justify-content-center mt-2">
                      <b-button variant="success" class="mr-1" @click="terimaBerkas(berkas.role)">Ya</b-button>
                      <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-terima')">Tidak</b-button>
                  </div>
                </b-modal>
              </div>

              <div>
                <b-button v-b-modal.modal-center-pembimbing-tolak variant="danger">Tidak Setuju</b-button>
                <b-modal id="modal-center-pembimbing-tolak" centered title="Konfirmasi" :hide-footer="true">
                  <center><p>Berikan catatan penolakan</p></center>
                  <b-form-textarea
                    placeholder="Catatan penolakan"
                    v-model="catatanPenolakan"
                  />
                  <div class="d-flex justify-content-center mt-2">
                      <b-button variant="success" class="mr-1" @click="tolakBerkas(berkas.role)">Kirim</b-button>
                      <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-tolak')">Batal</b-button>
                  </div>
                </b-modal>
              </div>
            </div>

            <div class="d-flex justify-content-center" v-if="berkas.role == 'superadmin' && berkas.status_sidang_id == 2">
              <div class="mr-1">
                <b-button v-b-modal.modal-center-pembimbing-terima variant="primary">Setuju</b-button>
                <b-modal id="modal-center-pembimbing-terima" centered title="Konfirmasi" :hide-footer="true">
                  <center><p>Apakah anda ya yakin ingin menerima berkas ini?</p></center>
                  <div class="d-flex justify-content-center mt-2">
                      <b-button variant="success" class="mr-1" @click="terimaBerkas(berkas.role)">Ya</b-button>
                      <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-terima')">Tidak</b-button>
                  </div>
                </b-modal>
              </div>

              <div>
                <b-button v-b-modal.modal-center-pembimbing-tolak variant="danger">Tidak Setuju</b-button>
                <b-modal id="modal-center-pembimbing-tolak" centered title="Konfirmasi" :hide-footer="true">
                  <center><p>Berikan catatan perbaikan</p></center>
                  <b-form-textarea
                    placeholder="Catatan Perbaikan"
                    v-model="catatanPenolakan"
                  />
                  <div class="d-flex justify-content-center mt-2">
                      <b-button variant="success" class="mr-1" @click="tolakBerkas(berkas.role)">Kirim</b-button>
                      <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-tolak')">Batal</b-button>
                  </div>
                </b-modal>
              </div>
            </div>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <div>
        <b-modal id="modal-center-loading" centered title="Loading" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close v-if="showModal === 1">
          <div v-if="this.error_check.length == 0">
            <div class="d-flex justify-content-center mt-2">
              <b-spinner
              :variant="'dark'"
              ></b-spinner>
            </div>
            <div class="d-flex justify-content-center mt-2">
            Loading....
            </div>
          </div>
          <div v-else>
            <div class="d-flex justify-content-center mt-2">
              <h4 style="color:red;">Gagal Memuat Data</h4>
            </div>
          </div>
          <b-button class="mt-3" block @click="reload()" variant="primary">Muat Ulang</b-button>
        </b-modal>
      </div>
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import JadwalSidangDosen from '@/views/pages/jadwal-sidang-dosen/list/List.vue'
import flatPickr from 'vue-flatpickr-component'
import "flatpickr/dist/flatpickr.min.css";
import { Indonesian } from "flatpickr/dist/l10n/id.js";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BCalendar,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
  BFormTextarea,
  BModal,
  BSpinner,
  BTooltip,
  BTable,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { codeIcon } from './code'
import {
  getUserDetail,
  getJurusan,
  getJenjang,
  getProdi,
  getPeminatan,
  getJenisSidang,
  getProsesPersidangan,
  getDosen,
  postBerkas,
  updateBerkas,
  getPengajuanSidangDetail,
  uploadFilePengajuan,
  downloadDokumen,
  getRuangan,
  getProgram,
  getWaktuUjian,
  getJawabanPersetujuan,
  simpanNoteBerkas,
  postTerimaBerkas,
  postTolakBerkas,
} from '@/connection-api/master'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    BButton,
    BCalendar,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    BFormTextarea,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BModal,
    BSpinner,
    BTooltip,
    BTable,
    JadwalSidangDosen,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
      // 15th two months prior
      const minDate = new Date('2023-06-12')
      minDate.setDate(minDate.getDate())
      // 15th in two months
      const maxDate = new Date('2023-07-12')
      maxDate.setDate(maxDate.getDate())

    return {
      flatpickrConfig: {
        enableTime: false, // Adjust as needed
        dateFormat: "d-m-Y",
        // disable: ["2023-12-25"], // Example of specific date disable
        locale: Indonesian,
        timeZone: "Asia/Jakarta",
      },
      surat_tugas: {},
      jadwal_sidang: {},
      ruangan_terpakai: [
        {ruangan: 'Tidak ditemukan ruangan terpakai'}
      ],
      tim_pembimbing: [
        {nama_mahasiswa: 'Kucil', judul: 'Korespondensi antara A dan B', pembimbing: 'Prof. Testing', utama: 'Ya'}
      ],
      tim_penguji: [
        {nama_mahasiswa: 'Kucil', judul: 'Korespondensi antara A dan B', nama_penguji: 'Prof. Testing', peran: 'Penguji 1 (Ketua Sidang)'},
        {nama_mahasiswa: 'Kucil', judul: 'Korespondensi antara A dan B', nama_penguji: 'Prof. Testing', peran: 'Pembimbing 1 (Sekertaris Sidang)'},
        {nama_mahasiswa: 'Kucil', judul: 'Korespondensi antara A dan B', nama_penguji: 'Prof. Testing', peran: 'Penguji 2'},
      ],
      catatanPenolakan: null,
      showSpinner: 0,
      showSpinnerPembimbing: 0,
      showSpinnerPenguji: 0,
      success_check: [],
      error_check: [],
      tahunOptions: [],
      showModal: 1,
      file: {
        file_persetujuan_pembimbing: null,
        file_ringkasan_turnitin: null,
        file_riwayat_pembayaran_bop: null,
        file_berkas_lengkap_skripsi: null,
        file_screenshoot_siak_ng: null,
      },
      minTime: '08:00',
      maxTime: '16:00',
      min: minDate,
      max: maxDate,
      selectedContry: '',
      selectedLanguage: '',
      userData: {},
      berkas: {},
      required,
      email,
      codeIcon,
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      languageName: [
        { value: 'nothing_selected', text: 'Nothing Selected' },
        { value: 'English', text: 'English' },
        { value: 'Chinese', text: 'Mandarin Chinese' },
        { value: 'Hindi', text: 'Hindi' },
        { value: 'Spanish', text: 'Spanish' },
        { value: 'Arabic', text: 'Arabic' },
        { value: 'Malay', text: 'Malay' },
        { value: 'Russian', text: 'Russian' },
      ],
      jurusanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jurusan --' },
        ],
      },
      jenjangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenjang --' },
        ],
      },
       programOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Program --' },
        ],
      },
      peminatanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Peminatan --' },
        ],
      },
      prodiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Prodi --' },
        ],
      },
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenis Sidang --' },
        ],
      },
      prosesPersidanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Skema Ujian --' },
        ],
      },
      dosenOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Dosen --' },
        ],
      },
      dosenUtamaOption: {
        selected: 'id',
        options: [
          { value: null, title: 'Pilih' },
          { value: 'ya', title: 'Ya' },
          { value: "tidak", title: 'Tidak' },
        ],
      },
      ruanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Ruangan --' },
        ],
      },
      waktuUjianOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Waktu --' },
        ],
      },
      waktuUjianPenetapanOption: {
        selected: 'uuid',
        options: [],
      },
      tanggalUjianPenetapanOption: {
        selected: 'uuid',
        options: [],
      },
      jawabanPersetujuanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jawaban --' },
        ],
      },
      jurusanSMAOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jurusan SMA --' },
          { value: 'IPA', title: 'IPA' },
          { value: 'IPS', title: 'IPS' },
          { value: 'Lainnya', title: 'Lainnya' },
        ],
      },
    }
  },
  mounted() {
      this.populateYearOptions();
      this.$bvModal.show('modal-center-loading')
      
      this.loadData()
    
  },
  methods: {
    async loadData(){
      getPengajuanSidangDetail(this.$route.params.uuid)
          .then(response => {
            this.berkas = response.data.data;
            this.jadwal_sidang = this.berkas.jadwal_sidang
            this.surat_tugas = this.berkas.surat_tugas
            this.tim_pembimbing = this.berkas.tim_pembimbing
            this.tim_penguji = this.berkas.tim_penguji
            this.success_check.push('success')
            this.completeCheck()

            this.jurusanOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Jurusan --' },
              ],
            }

            this.jenjangOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Jenjang --' },
              ],
            }

            this.programOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Program --' },
              ],
            }

            this.peminatanOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Peminatan --' },
              ],
            }

            this.prodiOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Prodi --' },
              ],
            }

            this.jenisSidangOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Jenis Sidang --' },
              ],
            }

            this.prosesPersidanganOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Skema Ujian --' },
              ],
            }

            this.dosenOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Dosen --' },
              ],
            }

            this.dosenUtamaOption = {
              selected: 'id',
              options: [
                { value: null, title: 'Pilih' },
                { value: 'ya', title: 'Ya' },
                { value: "tidak", title: 'Tidak' },
              ],
            }

            this.ruanganOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Ruangan --' },
              ],
            }

            this.waktuUjianOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Waktu --' },
              ],
            }

            this.waktuUjianPenetapanOption = {
              selected: 'uuid',
              options: [],
            }

            this.tanggalUjianPenetapanOption = {
              selected: 'uuid',
              options: [],
            }

            this.jawabanPersetujuanOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Jawaban --' },
              ],
            }

            this.jurusanSMAOption = {
              selected: 'id',
              options: [
                { value: null, title: '--Pilih Jurusan SMA --' },
                { value: 'IPA', title: 'IPA' },
                { value: 'IPS', title: 'IPS' },
                { value: 'Lainnya', title: 'Lainnya' },
              ],
            }

              if(this.berkas.ruangan_terpakai.length > 0)
              {
                this.ruangan_terpakai = []
                this.buildArray(this.berkas.ruangan_terpakai)
              }

              if(this.berkas.tanggal_ujian_penetapan.length > 0)
              {
                this.buildOption(this.berkas.tanggal_ujian_penetapan, this.tanggalUjianPenetapanOption)
              }

              if(this.berkas.waktu_ujian_penetapan.length > 0)
              {
                this.buildOption(this.berkas.waktu_ujian_penetapan, this.waktuUjianPenetapanOption)
              }

              if(this.berkas.jawaban.length > 0)
              {
                this.buildOption(this.berkas.jawaban, this.jawabanPersetujuanOption)
              }

              if(this.berkas.ruangan.length > 0)
              {
                this.buildOption(this.berkas.ruangan, this.ruanganOption)
              }

              if(this.berkas.dosen.length > 0)
              {
                this.buildOption(this.berkas.dosen, this.dosenOption)
              }

              if(this.berkas.waktu.length > 0)
              {
                this.buildOption(this.berkas.waktu, this.waktuUjianOption)
              }

              if(this.berkas.jurusan.length > 0)
              {
                this.buildOption(this.berkas.jurusan, this.jurusanOption)
              }

              if(this.berkas.proses_persidangan.length > 0)
              {
                this.buildOption(this.berkas.proses_persidangan, this.prosesPersidanganOption)
              }

              if(this.berkas.jenis_sidang.length > 0)
              {
                this.buildOption(this.berkas.jenis_sidang, this.jenisSidangOption)
              }

              // if(this.berkas.program.length > 0)
              // {
              //   this.buildOption(this.berkas.program, this.programOption)
              // }

              if(this.berkas.jenjang.length > 0)
              {
                this.buildOption(this.berkas.jenjang, this.jenjangOption)
              }

              if(this.berkas.prodi.length > 0)
              {
                this.buildOption(this.berkas.prodi, this.prodiOption)
              }

              if(this.berkas.peminatan.length > 0)
              {
                this.buildOption(this.berkas.peminatan, this.peminatanOption)
              }
          })
        .catch(error => {
          this.error_check.push(error)
        });
    },
    buildArray(data) {
      data.forEach(element => {
        this.ruangan_terpakai.push({
          nama: element.nama,
          judul: element.judul,
          ruangan: element.ruangan,
          tanggal: element.tanggal,
          waktu_ujian: element.waktu_ujian,
        })
      })
    },
    terimaBerkas(role)
    {
      this.$bvModal.show('modal-center-loading-persetujuan')
      this.showModal = 1
      var data = {
        role: role,
        catatan: this.catatanPenolakan,
        uuid: this.$route.params.uuid,
        nomor_surat: this.berkas.nomor_surat,
      }
      postTerimaBerkas(data)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          this.showModal = 0
          setTimeout(() => {
            this.$router.push({name: 'list-sidang'})
          }, 1000);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
          this.showModal = 0
        }
      })
      .catch(error => {
        this.showModal = 0
      });
    },
    tolakBerkas(role)
    {
      this.$bvModal.show('modal-center-loading-persetujuan')
      this.showModal = 1
       var data = {
        role: role,
        catatan: this.catatanPenolakan,
        uuid: this.$route.params.uuid,
      }
      postTolakBerkas(data)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          this.showModal = 0
          setTimeout(() => {
            this.$router.push({name: 'list-sidang'})
          }, 1000);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
          this.showModal = 0
        }
      })
      .catch(error => {
        this.showModal = 0
      });
    },
    simpanNote(uuid, note) {
      var data = {
        uuid: uuid,
        note: note,
      }
      simpanNoteBerkas(data)
      .then(response => {
          if(response.data.success == true)
          {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Pengajuan Sidang',
                icon: 'EditIcon',
                variant: 'success',
                text: 'Data berhasil disimpan',
              },
            })
            this.$root.$emit('bv::hide::modal', `bv-modal-note${uuid}`, '#btnShow')
          }
        })
      .catch(error => {
        this.error_check.push(error)
      });
    },
    buildOption(data, option) {
      data.forEach(element => {
        option.options.push({
          title: element.nama,
          value: element.uuid,
        })
      })
    },
    populateYearOptions() {
      const currentYear = new Date().getFullYear();
      const yearsToShow = 30; // Adjust this number as needed to show more or fewer years

      for (let i = currentYear; i >= currentYear - yearsToShow; i--) {
        this.tahunOptions.push({ value: i, title: i.toString() });
      }
    },
    completeCheck()
    {
      if(this.success_check.length > 0 && this.error_check.length == 0)
      {
        this.showModal = 0
      }
    },
    reload()
    {
      window.location.reload()
    },
    async downloadFile(file){
      const result = await downloadDokumen(file);
      const blob = new Blob([result.data], {type: 'application/vnd.ms-powerpoint'});
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      const date = new Date().toLocaleString(['ban', 'id']);
      const filename = `berkas-${date}.pptx`.replace(/[^a-z0-9_.-]/gi, '_'); // replaces invalid characters
      link.download = filename;
      link.href = url;

      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url)
    },
    async lihatFile(file) {
      try {
        if (typeof file === 'object') {
          // kode yang dijalankan jika file adalah object
          file = file.nama
        }
        const resp = await downloadDokumen(file);
        var type_file = file.substring(file.length - 4);
        if (type_file === ".pdf") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "application/pdf" })
          );
        }
        if (type_file === ".png" || type_file === ".PNG" || 
            type_file === ".jpg" || type_file === ".JPG" || 
            type_file === ".jpeg" || type_file === ".JPEG") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "image/" + type_file.slice(1) })
          );
        }
        window.open(this.imageFile);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Pengajuan Sidang',
            icon: 'EditIcon',
            variant: 'danger',
            text: 'File tidak ditemukan',
          },
          duration: 5000,
        })
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay()
      const day = date.getDate()
      // Return `true` if the date should be disabled
      // return weekday === 0 || weekday === 6 || day === 14
        return weekday === 0
    },
    formSubmitted() {
      if(this.$can('all','manage') && this.berkas.status_pengajuan_sidang_id == 'ae7ebb35d51267ce')
      {
        if(window.confirm('Apakah anda yakin ingin ?'))
        {
          this.berkas.flag = 'Ruangan Sidang'
          updateBerkas(this.berkas)
              .then(response => {
                if (response.data.success == true) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Pengajuan Sidang',
                      icon: 'EditIcon',
                      variant: 'success',
                      text: 'Data berhasil disimpan',
                    },
                    duration: 5000,
                  })
                  this.showModal = 0
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Pengajuan Sidang',
                      icon: 'EditIcon',
                      variant: 'success',
                      text: 'Data berhasil disimpan',
                    },
                  })
                  this.showModal = 0
                }
              })
              .catch(error => {
                this.showModal = 0
              });
        }
      } else {
        if(window.confirm('Apakah anda yakin ingin meninggalkan berkas sidang ini ?'))
        {
          this.$router.push({name: 'list-sidang'})
        }
      }
      
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            if(this.berkas.role != 'mahasiswa')
            {
              this.berkas.flag = 'update-penguji'
              updateBerkas(this.berkas)
              .then(response => {
                if (response.data.success == true) {
                  this.loadData()
                  resolve(true)
                } else {
                  reject()
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Pengajuan Sidang',
                      icon: 'EditIcon',
                      variant: 'danger',
                      text: response.data.message,
                    },
                  })
                }
              })
              .catch(error => console.log(error));
            } else if(this.berkas.role == 'mahasiswa') {
              resolve(true)
            }
          } else {
            reject()
          }
        })
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress2() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules2.validate().then(success => {
          if (success) {
            this.berkas.flag = 'jadwal-sidang'
            updateBerkas(this.berkas)
            .then(response => {
              if (response.data.success == true) {
                resolve(true)
              } else {
                reject()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
            .catch(error => console.log(error));
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress3() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules3.validate().then(success => {
          if (success) {
            this.berkas.flag = 'surat-tugas'
            updateBerkas(this.berkas)
            .then(response => {
              if (response.data.success == true) {
                resolve(true)
              } else {
                reject()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: response.data.message,
                  },
                })
              }
            })
            .catch(error => console.log(error));
            // resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
